import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Col, Row, Card } from '@themesberg/react-bootstrap'
import { useCookies } from 'react-cookie'
import { Context } from '../TransactionHistory'
import { getSummaryMoneyLog } from '../../../../controller/api/moneyLog'

const StatCard = ({ title, value, variant, hint }) => (
  <Card border="light" className={`shadow-sm h-100 border-0 border-start border-4 border-${variant}`}>
    <Card.Body className="py-3 px-4">
      <div className="text-muted small fw-bold text-uppercase mb-1">{title}</div>
      <h4 className={`fw-bold text-${variant} mb-0`}>
        {new Intl.NumberFormat('vi-VN').format(value)}
      </h4>
      {hint && <div className="text-muted small mt-1">{hint}</div>}
    </Card.Body>
  </Card>
)

const _Summary = () => {

  const { state } = useContext(Context);
  const [cookies] = useCookies(['lottmekong'])

  const [summary, setSummary] = useState({
    count: 0,
    credit: 0,
    debit: 0,
    net: 0
  })

  const getSummaryFunc = useCallback(async () => {
    const response = await getSummaryMoneyLog(cookies.lottmekong, {
      from: state.filter.from,
      to: state.filter.to,
      phone: state.filter.phone,
      wallet: state.filter.wallet
    })

    if (response) {
      setSummary({
        count: Number(response.count) || 0,
        credit: Number(response.credit) || 0,
        debit: Number(response.debit) || 0,
        net: Number(response.net) || 0
      })
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.phone, state.filter.wallet])

  useEffect(() => {
    getSummaryFunc()
  }, [getSummaryFunc, state.filterPressCount])

  return (
    <Row className="g-3">
      <Col md={3} sm={6} xs={6}>
        <StatCard title="Số giao dịch" value={summary.count} variant="primary" hint="Số dòng phát sinh trong kỳ" />
      </Col>
      <Col md={3} sm={6} xs={6}>
        <StatCard title="Tiền vào" value={summary.credit} variant="success" hint="Nạp tiền, trúng thưởng, hoàn tiền" />
      </Col>
      <Col md={3} sm={6} xs={6}>
        <StatCard title="Tiền ra" value={summary.debit} variant="danger" hint="Mua vé, rút tiền, thu hồi" />
      </Col>
      <Col md={3} sm={6} xs={6}>
        <StatCard title="Chênh lệch" value={summary.net} variant="info" hint="Tiền vào trừ tiền ra" />
      </Col>
    </Row>
  );
};

export default React.memo(_Summary)
